import { tProject } from '../../lib/project-i18n';

/**
 * ──────────────────────────────────────────────────────────────────────────────
 * ⭐ **되돌려졌다가 2026-10-01 에 다시 선 파일이다.** 그 사정을 여기 둔다 —
 *   이 파일이 다시 지워질 뻔하면 다음 사람이 이 글을 먼저 읽게 된다.
 *
 * ```
 * 되돌린 커밋   1b88bb8aa  Revert "feat(project): 화면설계서 v2.2 나머지 화면 6종" (PR #503)
 * 되돌린 까닭   「운영에 라우트도 표도 «없는데» 화면이 실려 나가, 배포마다 그 커밋만 빼고
 *               빌드해야 했다」 — #508 · CLAUDE.md 「작업 규칙」 절의 그 사건
 * ⇒ ★ 그 까닭이 «이 파일에는 닿지 않는다». 재서 확인한 것:
 *     기대는 것      lib/project-i18n «하나»뿐
 *     서버 칸 0  ·  라우트 0  ·  API 호출 0      ⇒ 순수 함수다
 * ⇒ ⇒ 그래서 2026-10-01 사용자 승인으로 되돌림을 «풀었다».
 * ```
 *
 * ⚠ 되살리기 전에 «넣어서 돌려 봤다» — 28건 중 21 통과 · 7 실패였고, 실패 일곱이 «전부»
 *   i18n 키가 없어서였다(`project.mytask.*` 가 main 사전에 0건). 그 열다섯을 함께 넣어 28/28 이 됐다.
 *   ⇒ ★ 「무엇이 남았나」를 «돌려 보고» 알아낸 자리다 — 읽기만 해서는 그 7 을 못 봤을 것이다.
 *
 * ⛔ 그리고 이것을 **`tsc` 는 안 잡는다** — 이 파일을 되살려도 타입은 맞는다(사보타주로 확인).
 *   그래서 서기 전까지는 `project-rowextras-canon-gap.guard.test.ts` 가 그 사실을 들고 있었다.
 *   **그 가드는 이 판에서 지웠다** — 만료 조건이 다 찼기 때문이다(가드의 몫은 시험이 받았다).
 *
 * ⚠ 지금 이 부품을 «쓰는 화면은 0곳»이다(`MyTasksRowExtras` 가 부르고, 그쪽도 화면에 안 붙었다).
 *   붙이는 일은 「내 할일 표」를 갈아끼우는 판이다 — 그때 이 규칙이 저절로 따라온다.
 * ──────────────────────────────────────────────────────────────────────────────
 *
 * AW-004-01 (2026-08-18) — 내 업무의 **기한 표시 규칙**.
 *
 * 설계서가 고친 것: "D-49" 와 "12일 지연" 이 섞여 있어 같은 열을 읽는 방식이 두 가지였다.
 * 규칙을 하나로 통일한다 — **상태 문구 + 실제 마감일 날짜**.
 *   지연 / 오늘 마감 / 내일 마감 / N일 남음, 그리고 완료된 업무는 그냥 '완료'.
 *
 * 색은 상태·위험도에만 쓴다: 완료=초록 · 지연/임박=주황 · 그 외는 색 없음.
 *
 * ## ⭐⭐ 「정본 그대로 이관」에서 ★ 이 파일은 ⇒ ⭐ «뺀다» (2026-10-10 · 관제 결정)
 *
 * 까닭 ⇒ ★ 덮을 ⭐ «이득이 0» 이다 — ⇒ 정본과 ★ ⭐ «코드가 같다».
 *
 *   잰 법 ⇒ node scripts/ops/mask-code.mjs <파일>  ⇒ ★ 빈 줄을 접고 diff
 *          정본 dd05a6fcd ⇒ 날 줄 66 · 코드 줄 44
 *          우리 b344a7349 ⇒ 날 줄 92 · 코드 줄 44
 *          ⇒ ★ diff 차이 ⭐ 0 줄 · 접은 md5 ⇒ 양쪽 ★ c43998f7889e
 *   ⇒ ⇒ ⭐ 즉 날 줄 차이 ★ 26 은 ⇒ 위 «PR 503 되돌림 · PR 508» 기록 ★ 그것뿐이다.
 *
 * ⚠⚠ 재는 법에 ★ 함정이 ⭐ 하나 있다 — ⇒ 내가 ★ 먼저 걸렸다:
 *   ⛔ 가린 글을 ★ «그대로» md5 하면 ⇒ ⭐ 갈린다(aa9886f49d ⇔ c2ffb37cb9)
 *   ⇒ ★ 까닭 ⇒ ⭐ 가리개가 ★ 주석을 «빈 줄»로 만든다 ⇒ ⇒ 주석 자리가 다르면 ★ 빈 줄 자리도 다르다
 *   ⇒ ⇒ ✅ 그래서 ★ ⭐ «빈 줄을 접은 뒤» 재야 ⇒ 「코드가 같나」가 보인다.
 *
 *   ⇒ ⭐⭐ 그래서 ★ 재는 «명령»을 ⇒ ⭐ 여기 못 박는다 (⇒ 2026-10-10 관제 요청):
 *      node scripts/ops/mask-code.mjs <파일> | grep -E '[^[:space:]]' | md5sum
 *      ⇒ ⇒ ★ 그 `grep` 이 ⭐ «빈 줄을 버린다» — ⇒ ★ 그것이 ⭐ «접는» 것이다.
 *   ⇒ ⚠ ⛔ 그 접기를 ★ 빼면 ⇒ ⭐ 해시가 갈린다 ⇒ ⇒ ★ 그것을 ⭐ «결함»으로 읽지 마라 —
 *      ⇒ ⇒ ★ 갈린 것은 ⭐ «주석 자리»일 뿐이다(코드는 같다).
 *   ⇒ ⇒ ⭐ 실제로 ★ 2026-10-10 에 ⇒ 관제와 내가 ★ 이 자리에서 ⭐ 서로 다른 해시를 들고 만났다
 *      ⇒ ⇒ 관제 ⇒ 양쪽 12a5c44ac6 (⇐ ★ 위 grep 을 ⭐ 썼다)
 *      ⇒ ⇒ 나   ⇒ ⛔ aa9886f49d ⇔ c2ffb37cb9 (⇐ ★ 접지 ⭐ 않았다)
 *      ⇒ ⇒ ⇒ ★ 둘 다 ⭐ 「같다」를 뜻했다 — ⇒ ★ 가른 것은 ⭐ «재는 법»이었다.
 *
 * ⏳ 만료 조건 — ★ «이름»과 ⭐ «측정»으로
 *   ⇒ ① 정본 `my-task-due` 가 ★ 우리에 없는 이름을 ⭐ 내놓는 날
 *      (지금 양쪽 export ⇒ DueState · dueDayDiff · dueState · dueStateLabel · isAtRisk)
 *   ⇒ ② 또는 ★ 위 «빈 줄 접은 diff» 가 ⇒ ⭐ 0 이 아닌 날
 *   ⇒ ⇒ ★ 그때는 ⭐ 이 글을 지우고 ★ 정본 글자로 덮어라.
 *   ⇒ ⛔ 「날 줄 수가 다르다」로 재지 ★ 마라 — ⇒ ⭐ 그것은 «주석 수»다(지금 26 줄 차이가 그것이다).
 * 지연이라고 행 전체를 빨갛게 덮지 않는다(설계서 2.1 색상 기준 통일) — 기한 텍스트만 물들인다.
 */

export type DueState = 'done' | 'overdue' | 'today' | 'tomorrow' | 'left';

/** 로컬 자정 기준 일수 차 (due - today). 파싱 불가면 NaN. */
export function dueDayDiff(dueDate: string, now: number = Date.now()): number {
  const d = new Date(dueDate);
  if (Number.isNaN(d.getTime())) return NaN;
  const t = new Date(now);
  const a = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
  const b = Date.UTC(t.getFullYear(), t.getMonth(), t.getDate());
  return Math.round((a - b) / 86_400_000);
}

/** 기한 상태. 마감일이 없으면 null(완료는 마감일이 없어도 'done'). */
export function dueState(
  dueDate: string | null | undefined,
  status: string,
  now: number = Date.now(),
): DueState | null {
  if (status === 'DONE') return 'done';
  if (!dueDate) return null;
  const diff = dueDayDiff(dueDate, now);
  if (Number.isNaN(diff)) return null;
  if (diff < 0) return 'overdue';
  if (diff === 0) return 'today';
  if (diff === 1) return 'tomorrow';
  return 'left';
}

export function dueStateLabel(
  state: DueState,
  dueDate: string | null | undefined,
  now: number = Date.now(),
): string {
  if (state === 'done') return tProject('project.mytask.due_done');
  const diff = dueDate ? dueDayDiff(dueDate, now) : NaN;
  if (state === 'overdue') return tProject('project.mytask.due_overdue', { n: String(Math.abs(diff) || 1) });
  if (state === 'today') return tProject('project.mytask.due_today');
  if (state === 'tomorrow') return tProject('project.mytask.due_tomorrow');
  return tProject('project.mytask.due_left', { n: String(diff) });
}

/**
 * 위험 판정 — **지연 + 우선순위 높음 + 미완료**.
 * AW-001 프로젝트메인의 '위험' 지표와 같은 정의를 쓴다(화면마다 다른 뜻이 되면 숫자가 안 맞는다).
 */
export function isAtRisk(
  dueDate: string | null | undefined,
  status: string,
  priority: string,
  now: number = Date.now(),
): boolean {
  return priority === 'HIGH' && dueState(dueDate, status, now) === 'overdue';
}
